import { createFeatureSelector, createSelector } from '@ngrx/store';
import { _STATE_UNIVERSITY_FEATURE_KEY, State } from './university.reducer';

// Lookup the 'StateUniversity' feature state managed by NgRx
export const getStateUniversityState = createFeatureSelector<State>(
	_STATE_UNIVERSITY_FEATURE_KEY,
);

export const getStateUniversity = createSelector(
	getStateUniversityState,
	(state: State) => state.university,
);

export const getStateClearingUniversity = createSelector(
	getStateUniversityState,
	(state: State) => state.clearingUniversity,
);

export const getStateUniversityRatingStats = createSelector(
	getStateUniversityState,
	(state: State) => state.universityRatingStats,
);

export const getStateUniversityUrl = createSelector(
	getStateUniversityState,
	(state: State) => state.universityUrl,
);

export const getStateIsLoading = createSelector(
	getStateUniversityState,
	(state: State) => state.isLoading,
);

export const getStateUniversityError = createSelector(
	getStateUniversityState,
	(state: State) => state.error,
);
